import { Fragment, memo } from "react";

import classnames from "classnames";

const LayoutWrapper = (props) => {
  // ** Props
  const { children, routeMeta } = props;

  //** Vars
  const Tag = Fragment;

  return (
    <div
      className={classnames("app-content content", {
        [routeMeta ? routeMeta.className : ""]:
          routeMeta && routeMeta.className,
        safari: navigator.userAgent?.indexOf("Chrome") === -1
      })}
    >
      <div className="content-overlay"></div>
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          "content-wrapper"     : routeMeta && !routeMeta.appLayout,
          "content-area-wrapper": routeMeta && routeMeta.appLayout
        })}
      >
        <Tag>{children}</Tag>
      </div>
    </div>
  );
};

export default memo(LayoutWrapper);
